export const getEmployeeBranch = (userString) => {
    return new Promise((resolve, reject) => {
        const userInfo = parseUserString(userString);

        if (userInfo.employeeNumber === '') {
            resolve('');
            return;
        }

        $.get('/Account/UserInfo/GetUserViewpointBranch', {userId: userInfo.employeeNumber}, (response) => {
            resolve(response);
        })
    })
}

const parseUserString = (userString) => {
    const hyphenIndex = userString.indexOf('-');
    const employeeNumber = userString.substring(0, hyphenIndex).trim();
    const openParenthesesIndex = userString.indexOf("(");
    const closeParenthesesIndex = userString.indexOf(")");
    const employeeName = userString.substring(hyphenIndex + 1, openParenthesesIndex).trim();
    const employeeTitle = userString.substring(openParenthesesIndex + 1, closeParenthesesIndex).trim();

    return {
        employeeNumber: employeeNumber,
        employeeName: employeeName,
        employeeTitle: employeeTitle
    }
}